import axios from 'axios'

const MemoService = {
  async get (params = {}) {
    return axios.get('asm/memos', { params })
  },

  async histories (params = {}) {
    return axios.get('asm/reports/memos', { params })
  },

  async show (id) {
    return axios.get(`asm/memos/${id}`)
  },

  async post (params = {}) {
    return axios.post('asm/memos', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`asm/memos/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`asm/memos/${data.id}`, { data })
  }
}

export default MemoService
